import { authenticatedMiddleware } from '@/middleware/AuthenticatedMiddleware.js'
import SiteVerificationCode from '@/views/authenticated/verification/Code.vue'
import SiteVerificationGeo from '@/views/authenticated/verification/Geo.vue'

export const verificationRoutes = [
  {
    path: '/verification/geo',
    name: 'verification.geo',
    component: SiteVerificationGeo,
    beforeEnter: [authenticatedMiddleware],
  },
  {
    path: '/verification/code',
    name: 'verification.code',
    component: SiteVerificationCode,
    beforeEnter: [authenticatedMiddleware],
  },
]
